import { render, staticRenderFns } from "./ptspkabupaten.vue?vue&type=template&id=30573907"
import script from "./ptspkabupaten.vue?vue&type=script&lang=js"
export * from "./ptspkabupaten.vue?vue&type=script&lang=js"
import style0 from "./ptspkabupaten.vue?vue&type=style&index=0&id=30573907&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports